import React from 'react';
import { useAppVersionCheck } from '../../hooks/useAppVersionCheck';

const AppUpdateBanner: React.FC = () => {
  const { updateAvailable, refresh } = useAppVersionCheck();

  if (!updateAvailable) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-8 left-4 right-4 z-[10000] mx-auto max-w-md rounded-lg border border-sky-200 bg-sky-50 px-4 py-3 shadow-lg"
    >
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm text-sky-900">
          A new version is available.
        </p>
        <button
          type="button"
          onClick={refresh}
          className="shrink-0 rounded-md bg-sky-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
        >
          Refresh
        </button>
      </div>
    </div>
  );
};

export default AppUpdateBanner;
